import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainEntryComponent } from './main-entry.component';
import { KngButtonModule, KngFooterModule, KngLoaderModule } from 'kinetic-angular';
import { AuthenticationServiceModule } from '../../services/authentication/authentication.module';
import { LoggerServiceModule } from '../../services/logger/logger.module';
import{ SafeHtmlPipeModule } from '../../../app/pipes/safehtml/safehtml.pipe.module';
@NgModule({
	declarations: [MainEntryComponent],
	imports: [
		CommonModule,
		KngButtonModule,
		KngFooterModule,
		AuthenticationServiceModule,
		LoggerServiceModule,
		KngLoaderModule,
		SafeHtmlPipeModule
	],
	exports: [MainEntryComponent]
})
export class MainEntryModule {}
